import { LinkType } from '../../abacus/enums/link-type.enum'
import { ResourceDefinition } from '../../abacus/interfaces/resource-definition.interface'

export const countryDefinition: ResourceDefinition = {
  title: 'Countries/Territories',
  nameSingular: 'Country/Territory',
  namePlural: 'Countries/Territories',
  className: 'Country',
  mainIdentifier: 'name',
  slug: 'countries',
  path: 'countries',
  icon: 'icon-map',
  hasDetailPage: false,
  hasListPage: true,
  buttons: [],
  defaultLink: LinkType.DETAIL,
  childrenThatPreventDelete: [],
  dropdownLinks: []
}
